import React from 'react'

import {Loading} from './Loading'
import {Message} from './Message'
import {Download} from './Download'

export function DownloadState({ext, rapid}) {
  return (
    <>
      {ext.loading && <Loading />}
      {ext.message && <Message message={ext.message} />}
      {ext.downloadLink && <Download href={ext.downloadLink} ctaLbl={ext.ctaLbl} rapid={rapid} />}
    </>
  )
}
